export default "__VITE_ASSET__D4_DwyGx__"